import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/slack': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M244.2 217.5L263.5 275.2 203.7 295.2 184.4 237.5 244.2 217.5zM285.6 461.2C131.6 507.4 65 471.6 18.8 317.6S8.4 97 162.4 50.8C316.4 4.6 383 40.4 429.2 194.4 475.4 348.4 439.6 415 285.6 461.2zM366.2 265C362.3 252.8 349 246.4 336.8 250.3L307.8 260 288.5 202.3 317.5 192.6C329.7 188.7 336.1 175.4 332.2 163.2 328.3 151 315 144.6 302.8 148.5L273.8 158.2 263.8 128.1C259.9 115.9 246.6 109.5 234.4 113.4 222.2 117.3 215.8 130.6 219.7 142.8L229.7 172.9 169.9 193 159.9 162.9C156 150.7 142.7 144.3 130.5 148.2 118.3 152.1 111.9 165.4 115.8 177.6L125.8 207.7 96.8 217.4C84.6 221.3 78.2 234.6 82.1 246.8 85.3 256.1 94.3 262.2 103.6 262.6 107.9 263.2 111.3 261.6 140.5 251.9L159.8 309.6 130.8 319.3C118.6 323.2 112.2 336.5 116.1 348.7 119.3 358 128.3 364.1 137.6 364.5 141.9 365.1 145.3 363.5 174.5 353.8L184.5 383.9C188.2 394.7 200.3 402.5 213.9 398.6 226.1 394.7 232.5 381.4 228.6 369.2L218.6 339.1 278.4 319 288.4 349.1C292.1 359.9 304.2 367.7 317.8 363.8 330 359.9 336.4 346.6 332.5 334.4L322.5 304.3 351.5 294.6C363.7 290.4 370.1 277.1 366.2 265z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/slack.js
// module id = q287
// module chunks = 144